<template>
	<div class='post-wrapper'>
		<div class='post-wrapper__author'>
			<div class='profile'>
				<a class='image-wrapper' v-if='post.created_by.photo_small' :href='`/profile/${post.created_by.id}/`'>
					<img :src='post.created_by.photo_small'>
				</a>
				<div class='info'>
					<a class='name' :href='`/profile/${post.created_by.id}/`'>
						{{ post.created_by.name }}
					</a>
					<div class='date'>
						{{ post.created_at|formatDate }}
					</div>

				</div>
			</div>
			<div class='icon-wrapper dropdown-wrapper'>
				<div class='dropdown-wrapper-content show'
					v-if='showMenu && (showReportBtn || showDeleteBtn)'
					v-click-outside='hideMenuHandle'>
					<a @click='complainPostHandle' v-if='showReportBtn'>Report</a>
					<a @click='deletePostHandle' v-if='showDeleteBtn'>Delete</a>
				</div>
				<div @click='showMenuHandle' v-if='showReportBtn || showDeleteBtn'>
					<svg xmlns='http://www.w3.org/2000/svg'
						width='24'
						height='6'
						viewBox='0 0 24 6'
						fill='none'>
						<circle cx='3'
							cy='3'
							r='3'
							fill='#C4C4C4'/>
						<circle cx='12'
							cy='3'
							r='3'
							fill='#C4C4C4'/>
						<circle cx='21'
							cy='3'
							r='3'
							fill='#C4C4C4'/>
					</svg>
				</div>
			</div>
		</div>
		<div class='post-wrapper__text'>
			<pre>{{ post.text }}</pre>
		</div>
		<div class='post-wrapper__attachments'>
			<div class='attachment' v-for="(attachment, a) in post.attachments.filter(attachment => !['xls', 'xlsx', 'XLS', 'XLS', 'doc', 'docx', 'DOC', 'DOCX', 'pdf'].includes(attachment.extension))" :key='a'>
				<img :src='attachment.file'>
			</div>
		</div>
		<div class='post-wrapper__attachments-file'>
			<div class='attachment-file' v-for="(attachment, a) in post.attachments.filter(attachment => ['xls', 'xlsx', 'XLS', 'XLS', 'doc', 'docx', 'DOC', 'DOCX', 'pdf'].includes(attachment.extension))" :key='a'>
				<a :href="attachment.file" target="_blank">
					<div class="file-container">
						<svg class='icon'>
							<use v-if="['xls', 'xlsx', 'XLS', 'XLS'].includes(attachment.extension)" xlink:href='#icon-file-excel' style="color: green;"/>
							<use v-if="['doc', 'docx', 'DOC', 'DOCX'].includes(attachment.extension)" xlink:href='#icon-file-word' style="color: blue;"/>
							<use v-if="['pdf'].includes(attachment.extension)" xlink:href='#icon-file-pdf' style="color: red;"/>
						</svg>
						<p>{{ attachment.filename }}</p>
					</div>
				</a>
			</div>
		</div>
		<div v-if='hasUserSubscriptions' class='post-wrapper__comment' >
			<div class='comment-btn' @click='leaveCommentHandle'>
				<svg xmlns='http://www.w3.org/2000/svg'
					width='19'
					height='19'
					viewBox='0 0 19 19'
					fill='none'>
					<path
						d='M18 12.3333C18 12.8343 17.801 13.3147 17.4468 13.669C17.0925 14.0232 16.6121 14.2222 16.1111 14.2222H4.77778L1 18V2.88889C1 2.38792 1.19901 1.90748 1.55324 1.55324C1.90748 1.19901 2.38792 1 2.88889 1H16.1111C16.6121 1 17.0925 1.19901 17.4468 1.55324C17.801 1.90748 18 2.38792 18 2.88889V12.3333Z'
						stroke='black'
						stroke-width='2'
						stroke-linecap='round'
						stroke-linejoin='round'/>
				</svg>
				<div class='comment-text'>
					Leave comment
				</div>
			</div>

		</div>
		<div v-if='(post.comments_count > 0 || listOfComments.length>2) && !showTop'
			@click='showMoreHandle'
			class='showMoreComments'>Show more comments...
		</div>
		<div class='post-wrapper__comments-list' v-if='comments.top.length && showTop'>
			<Comment v-for='(comment, c) in comments.top.length'
				:key='`top${c}`'
				v-model='listOfComments[comments.top[c].index]'
				:post-id="post.id"
				@delete="handleCommentDelete(listOfComments[comments.top[c].index].id)"/>
		</div>
		<div class='post-wrapper__comments-list' v-if='comments.bottom.length'>
			<Comment v-for='(comment, c) in comments.bottom.length'
				:key='`bottom${c}`'
				v-model='listOfComments[comments.bottom[c].index]'
				:post-id="post.id"
				@delete="handleCommentDelete(listOfComments[comments.bottom[c].index].id)"/>
		</div>
		<MediaContainer v-model='media' hideButtonAdd/>
		<div v-if='hasUserSubscriptions' class='post-wrapper__leave-comment'>
			<a class='image-wrapper' v-if='profile.photo_small' :href='`/profile/${profile.id}/`'>
				<img :src='profile.photo_small'>
			</a>
			<div class='comment-field' :class="{'comment-field__active':inFocus}">
				<input type='text'
					v-model='text'
					class='inp'
					placeholder='Write a comment...'
					v-on:keyup.enter='createComment'
					ref='input'
					@focusin="inFocus=true"
					@focusout="inFocus=false"
				>
				<MediaSlot :ratio='[178, 108]'
					@input='cropHandle'
					:value='mediaElem'
					v-if='media.length < 4'
				>
					<div class="btn-upload-image">
						<svg width="19"
							height="16"
							viewBox="0 0 19 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path d="M17.5455 13.4444C17.5455 13.857 17.387 14.2527 17.1049 14.5444C16.8228 14.8361 16.4402 15 16.0413 15H2.50413C2.10521 15 1.72263 14.8361 1.44055 14.5444C1.15847 14.2527 1 13.857 1 13.4444V4.88889C1 4.47633 1.15847 4.08067 1.44055 3.78894C1.72263 3.49722 2.10521 3.33333 2.50413 3.33333H5.5124L7.01653 1H11.5289L13.0331 3.33333H16.0413C16.4402 3.33333 16.8228 3.49722 17.1049 3.78894C17.387 4.08067 17.5455 4.47633 17.5455 4.88889V13.4444Z"
								fill="white"
								stroke="#9AA5B6"
								stroke-linecap="round"
								stroke-linejoin="round"/>
							<path d="M9.27362 12.4551C11.0309 12.4551 12.4554 11.0305 12.4554 9.27325C12.4554 7.51598 11.0309 6.09143 9.27362 6.09143C7.51635 6.09143 6.0918 7.51598 6.0918 9.27325C6.0918 11.0305 7.51635 12.4551 9.27362 12.4551Z"
								fill="white"
								stroke="#9AA5B6"
								stroke-linecap="round"
								stroke-linejoin="round"/>
						</svg>
					</div>
				</MediaSlot>
				<SendButton v-if='showSendBtn' @click='createComment()'/>
			</div>
		</div>
	</div>
</template>

<script>
import global from '__jsVueMixin/global';
import Comment from './components/Comment/Comment.vue';
import api from '__jsVueApi';
import ClickOutside from 'vue-click-outside';
import MediaContainer from '__jsVueSections/MediaContainer/MediaContainer.vue';
import MediaSlot from '__jsVueSections/MediaSlot/MediaSlot.vue';
import EventBus from '__jsEbentBus';
import splitArray from '__jsVueMixin/splitArray';
import SendButton from '../../../SendButton.vue';

export default {
	name:       'Post',
	mixins:     [global, splitArray],
	components: {
		SendButton,
		Comment,
		MediaContainer,
		MediaSlot,
	},
	props: {
		post: {
			type: Object
		}
	},
	data() {
		return {
			text:           '',
			showMenu:       false,
			listOfComments: [],
			showTop:        false,
			media:          [],
			mediaElem:      {
				id:    false,
				image: {
					src:  false,
					blob: false
				}
			},

			commentsCount: 0,
			commentsPages: 0,

			inFocus:              false,
			hasUserSubscriptions: false
		};
	},
	mounted() {
		this.watchHandle();
		this.hasUserSubscriptions = !!this.$store.state.profile.profile.has_active_subscription;
	},
	computed: {
		showSendBtn() {
			if (this.text) {
				return true;
			}
			if (this.media.length) {
				for (let i = 0; i < this.media.length; i++) {
					const el = this.media[i];
					if (el.image.src) {
						return true;
					}
				}
			}
			return false;
		},
		comments() {
			return this.splitArrayLast(this.listOfComments, 2);
		},
		showReportBtn() {
			return !this.post.is_owner && !this.post.approval_required;
		},
		showDeleteBtn() {
			return this.post.is_owner || this.profile.is_admin;
		},
		profile() {
			return this.$store.state.profile.profile;
		},
	},
	methods: {
		watchHandle() {
			this.showTop = false;
			this.listOfComments = this.post.comments;
		},
		async showMoreHandle() {
			if (!this.showTop) {
				await this.getComments();
				this.showTop = true;
			}
		},
		leaveCommentHandle() {
			this.$refs.input.focus();
		},
		async deletePostHandle() {
			EventBus.$emit('confirm', {
				onOk: async() => {
					await axios.delete(api.posts.delete(this.post.id)).then(async(response) => {
						this.$toastr.i('<div class="toastr"><div class="toastr__check"></div><p class="toastr__text">Post has been deleted</p></div>');
						this.showMenu = false;
						await this.$emit('delete');
					}).catch(() => {
						this.showMenu = false;
					});
				},
				message: 'Do you really want to delete this post?'
			});
		},
		async complainPostHandle() {
			EventBus.$emit('confirm', {
				onOk: async() => {
					await axios.post(api.posts.complain(this.post.id)).then(async(response) => {
						this.$toastr.i('<div class="toastr"><div class="toastr__check"></div><p class="toastr__text">Post has been reported</p></div>');
						this.showMenu = false;
						await this.$emit('update');
					}).catch(() => {
						this.showMenu = false;
					});
				},
				message: 'Do you really want to report this post?'
			});
		},
		cropHandle(photo) {
			this.media = [
				...this.media, {
					id:    photo.id,
					image: {
						src:  photo.image.src,
						blob: photo.image.blob,
					}
				}
			];
		},
		hideMenuHandle() {
			if (this.showMenu) {
				this.showMenu = false;
			}
		},
		showMenuHandle() {
			setTimeout(() => {
				this.showMenu = true;
			}, 0);
		},
		async getComments() {
			let pageSize = 100;
			await axios.get(api.posts.comments.get(), {
				params: {
					post:      this.post.id,
					page_size: pageSize,
					page:      1,
				}
			}).then((response) => {
				this.commentsCount = response.data.count;
				this.commentsPages = Math.ceil(response.data.count / pageSize);
				this.listOfComments = response.data.results;
			});
			this.$store.commit('main/setLoad', false);
		},
		async createComment() {
			if (this.showSendBtn) {
				this.$store.commit('main/setLoad', true);
				let attachments = [];
				this.media.map((el) => {
					if (el.image.src) {
						attachments.push({
							image: el.image.src
						});
					}
				});
				await axios.post(api.posts.comments.create(this.post.id), {
					text:        this.text,
					attachments: attachments
				}).then(async(response) => {
					this.text = '';
					this.media = [];
					await this.getComments();
				});
			}
		},
		handleCommentDelete(id) {
			this.$emit('comment-delete', id);
		}
	},
	directives: {
		ClickOutside
	},
	watch: {
		post: {
			handler() {
				this.watchHandle();
			},
			deep: true
		}
	}
};
</script>
